<template>
    <div class="field checkboxes checkboxes--inline field--full" :class="{ 'required': required }">
        <div class="input">
            <label>
                <input
                    v-model="newValue"
                    type="checkbox"
                    :value="newValue"
                >
                <span />
                <p>{{ label }}</p>
            </label>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: [String, Boolean],
            default: false,
        },
        required: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            newValue: eval(this.value),
        }
    },

    watch: {
        newValue() {
            this.$emit('update:value', this.newValue);
            this.$emit('validate');
        },
    },

    methods: {
        isChecked() {
            return this.newValue === true;
        }
    },
}
</script>
<style lang="scss" scoped>
    .checkboxes--inline {
        label {
            align-items: center;
            cursor: pointer;
        }

        .input {
            em {
                font-style: normal;
            }
        }
    }
</style>
